import { CustomInputMappingField } from "../../../redux"
import { CustomInputValue } from "../getCustomInputFieldValue/getCustomInputFieldValue"
import { JsonDataType } from "../JsonDataType"

const resolveCond = (conditionValue: string | undefined, val1: CustomInputValue | undefined) => {
    if(!val1) return false
    if(!conditionValue) return false
    const val = Array.isArray(val1) ? val1 : val1.split(';')

    const correctValue = val
        .map(a => a?.trim?.() ?? '')
        .sort((a, b) => {
            if(a === b) return 0
            return a > b ? -1 : 1
        })
    const correctConditionValue = conditionValue
        .split(';')
        .map(a => a?.trim?.() ?? '')
        .sort((a, b) => {
            if(a === b) return 0
            return a > b ? -1 : 1
        })
    return correctConditionValue.some(val => correctValue.includes(val))
}

export const getFilterConditionField = (fields: CustomInputMappingField[], fieldsData: JsonDataType, businessId?: string) => { 
    const withConditionField = (fieldMapping: CustomInputMappingField) => {
        return !!fieldMapping.conditionField
    }

    const showAsCondition = (fieldMapping: CustomInputMappingField) => {
        const {conditionField, conditionValue} = fieldMapping
        if(!conditionField || !fields.length) return true
        const field = fields.find((f) => f.sourceField === conditionField)
        if(!field) return true

        if(field.type === 'businessId') return conditionValue === businessId

        return resolveCond(conditionValue, fieldsData[conditionField])
    }

    const showAsConditionParent = (fieldMapping: CustomInputMappingField) => {
        const {conditionField} = fieldMapping
        if(!conditionField || !fields.length) return true
        const field = fields.find((f) => f.sourceField === conditionField)
        if(!field) return true

        const {conditionField: conditionFieldParent, conditionValue: conditionValueParent} = field
        if(!conditionFieldParent || !fields.length) return true
        const fieldParent = fields.find((f) => f.sourceField === conditionFieldParent)
        if(!fieldParent) return true

        if(fieldParent.type === 'businessId') return conditionValueParent === businessId

        return resolveCond(conditionValueParent, fieldsData[conditionFieldParent])
    }
    const showAsConditionSubParent = (fieldMapping: CustomInputMappingField) => {
        const {conditionField} = fieldMapping
        if(!conditionField || !fields.length) return true
        const field = fields.find((f) => f.sourceField === conditionField)
        if(!field) return true

        const {conditionField: conditionFieldParent} = field
        if(!conditionFieldParent || !fields.length) return true
        const fieldParent = fields.find((f) => f.sourceField === conditionFieldParent)
        if(!fieldParent) return true

        const {conditionField: conditionFieldSubParent, conditionValue: conditionValueSubParent} = fieldParent
        if(!conditionFieldSubParent || !fields.length) return true
        const fieldSubParent = fields.find((f) => f.sourceField === conditionFieldSubParent)
        if(!fieldSubParent) return true

        if(fieldSubParent.type === 'businessId') return conditionValueSubParent === businessId
        
        return resolveCond(conditionValueSubParent, fieldsData[conditionFieldSubParent])
    }

    const filterConditionField = (fieldMapping: CustomInputMappingField) => {
        if(!withConditionField(fieldMapping)) return true
        const cond = showAsCondition(fieldMapping)
        if(!cond) return false
        const par = showAsConditionParent(fieldMapping)
        if(!par) return false
        const sub = showAsConditionSubParent(fieldMapping)
        return sub
    }

    return filterConditionField
}
